import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

export const getUserLabel = (user: UserShortInfo) => {
    const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();

    return name || user.email;
};
